export default __webpack_public_path__ + "static/media/confusionImg_5.d197149d.png";